import { Navigate, Outlet } from "react-router";

import { AppBreadcrumb } from "@/components/app-breadcrumb";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import useStore from "@/state";

export const DashboardLayout = () => {
  const { session } = useStore();

  if (!session) {
    return <Navigate to="/" />;
  } else if (!session.organization_id) {
    return <Navigate to="/no-organization" />;
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AppBreadcrumb />
        <div className="flex flex-1 flex-col px-12 mt-15 py-8">
          <Outlet />
        </div>
      </div>
    </SidebarProvider>
  );
};
